import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9b3ada"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"display":"flex","flex-flow":"column","align-items":"center","justify-content":"center","border":"solid 1px grey"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "MISSING Metadata, please update it!", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Transformer dashboard metadata")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_grafana_component = _resolveComponent("grafana-component")!
  const _component_grafana_timeframe_component = _resolveComponent("grafana-timeframe-component")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.meterId)
            ? (_openBlock(), _createBlock(_component_grafana_timeframe_component, { key: 0 }, {
                default: _withCtx(({ timeFrame }) => [
                  _createVNode(_component_grafana_component, {
                    src: "C_qa7JYMk/dashboard-transformator",
                    args: [`var-MeterId=${_ctx.meterId}`, timeFrame]
                  }, null, 8, ["args"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_ion_button, {
                  fill: "outline",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/dashboards/entities/transformer/${_ctx.trafoId}/metadata`)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}